import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { selectCurrentToken } from '../../features/Auth/authSlice';

const ProtectedRoute = ({ children, redirectPath = '/auth' }) => {
  const token = useSelector(selectCurrentToken);
  const location = useLocation();
  if (!token) {
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;
